import './sec13.css';

const Sec13 = () => {
    return (
        <div className="sec13-section">
        </div>
    );
};

export default Sec13;